import * as KanbanActions from "./kanbanActions";

export default KanbanActions;



// WEBPACK FOOTER //
// ./src/actions/KanbanActions/index.js